import { Tag } from "@/types/thread";

export const sortTags = (tags: Tag[]): Tag[] => {
  return [...tags].sort((a, b) => {
    if (a.isLora && !b.isLora) return -1;
    if (!a.isLora && b.isLora) return 1;
    if (a.rank === null && b.rank !== null) return 1;
    if (a.rank !== null && b.rank === null) return -1;
    if (a.rank !== null && b.rank !== null) return a.rank - b.rank;
    return 0;
  });
};
